import type { FC } from 'react'
import styled from 'styled-components'

import Detail from './Detail'

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 40px;
  grid-row-gap: 30px;
`

interface DetailT {
  label: string
  children: React.ReactNode
}

interface Props {
  details: DetailT[]
}

const DetailsList: FC<Props> = ({ details }) => (
  <Container>
    {details.map(({ label, children }, i) => {
      return (
        <Detail label={label} key={i}>
          {children}
        </Detail>
      )
    })}
  </Container>
)

export default DetailsList
